import { useDisconnect as useWagmiDisconnect } from "wagmi";

import { store } from "../store/store";
import { eAppActionTypes } from "../store/app/appTypes";
import { eUIActionTypes } from "../store/UI/UITypes";
import { eBasicActionTypes } from "../store/basic/basicTypes";
import { eChromiaActionTypes } from "../store/chromia/chromiaTypes";
import { eModalsActionTypes } from "../store/modals/modalsTypes";
import { eProActionTypes } from "../store/pro/proTypes";


export const useDisconnect = () => {
	const { disconnectAsync } = useWagmiDisconnect();
	// const { disconnectApp } = useStoreDispatch();

	const disconnect = async (disconnectWallet?: boolean) => {
		console.log('account disconected: ', disconnectWallet);
		if (disconnectWallet) {
			await disconnectAsync();	// disconnects all connected accounts
			localStorage.removeItem('WEB3_CONNECT_CACHED_PROVIDER');	// check this
			/* if (localStorage.getItem('walletconnect') && provider && provider.disconnect) {
				provider.disconnect();
			} */
		}

		setTimeout(() => {
			store.dispatch({
				type: eAppActionTypes.CLEAR_STATE
			});
		});
		setTimeout(() => {
			store.dispatch({
				type: eBasicActionTypes.SET_CURRENT_STEP,
				payload: 0
			});
		});
		setTimeout(() => {
			store.dispatch({
				type: eChromiaActionTypes.CLEAR_STATE
			});
		});
		setTimeout(() => {
			store.dispatch({
				type: eModalsActionTypes.CLEAR_STATE
			});
		});
		setTimeout(() => {
			store.dispatch({
				type: eProActionTypes.CLEAR_STATE
			});
		});
		setTimeout(() => {
			store.dispatch({
				type: eUIActionTypes.CLEAR_STATE
			});
		})
	};


	return disconnect;
}